import { LocationsService } from '@morningstar/shared/services/locations';
import { LocationsComponent } from './locations.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from 'apps/wsg/src/app/angular-material.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [ CommonModule, AngularMaterialModule, ReactiveFormsModule ],
  declarations: [ LocationsComponent ],
  exports: [ LocationsComponent ],
  providers: [ LocationsService ]
})
export class LocationsModule { }
